import React from 'react';

import { ChevronRightIcon } from '~/components/icon';
import { useIntl } from '~/contexts/intl';

import { Button } from './button';
import { OvalButton } from './oval-button';

type MessageHeaderButtonProps = {
    buttonText?: string;
    accessibilityLabel?: string;
    onPress: () => void;
};

export const MessageHeaderButton: React.FC<MessageHeaderButtonProps> = ({
    buttonText,
    accessibilityLabel,
    onPress
}) => {
    const { formatMessage } = useIntl();

    return buttonText ? (
        <Button size="small" onPress={onPress} label={buttonText} />
    ) : (
        <OvalButton
            size="small"
            onPress={onPress}
            icon={ChevronRightIcon}
            accessibilityLabel={accessibilityLabel ?? formatMessage('accessibility.open-profile')}
        />
    );
};
